var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"20px"}},[_c('query-form',{ref:"queryForm",staticClass:"form",attrs:{"coSeasonList":_vm.coSeasonList,"seasonList":_vm.seasonList},on:{"query":_vm.query}}),_c('activity-table',{ref:"mainTable",staticClass:"activityTable",attrs:{"seasonList":_vm.seasonList,"coSeasonList":_vm.coSeasonList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }